import './App.css';
import '@tron/composer-sdk/styles.css';
import 'react-toastify/dist/ReactToastify.css';

import { Route, Routes } from '@hulu/react-router-dom';
import { lazy, Suspense } from 'react';

import { StyledLoader } from './components/styled';
import { TOOLTIP_CONTAINER_ID } from './components/TooltipContainer/constants';
import { TooltipContainer } from './components/TooltipContainer/styled';
import { RoutePath } from './constants';
import { FeatureFlagsRouter } from './context/FeatureFlags';
import GhostModeContainer from './context/GhostMode';
import { AmplitudeProvider } from './hooks/analytics';
import lazyRetry from './utils/react/lazyRetry';

const AdminApp = lazy(() => lazyRetry(() => import('./AdminApp'), 'AdminApp'));
const MarketerApp = lazy(() => lazyRetry(() => import('./MarketerApp'), 'MarketerApp'));
const AuthHandoff = lazy(() => import('./pages/AuthHandoff/AuthHandoff'));
const Logout = lazy(() => lazyRetry(() => import('./pages/Logout'), 'Logout'));

export function App(): JSX.Element {
  return (
    <GhostModeContainer>
      <TooltipContainer id={TOOLTIP_CONTAINER_ID} />
      <Suspense fallback={<StyledLoader />}>
        <FeatureFlagsRouter>
          <AmplitudeProvider>
            <Routes>
              <Route path="/auth/handoff" element={<AuthHandoff />} />
              <Route path={RoutePath.LOGOUT} element={<Logout />} />
              <Route path={`${RoutePath.ADMIN}/*`} element={<AdminApp />} />
              <Route path="/*" element={<MarketerApp />} />
            </Routes>
          </AmplitudeProvider>
        </FeatureFlagsRouter>
      </Suspense>
    </GhostModeContainer>
  );
}

export default App;
